module.exports = __webpack_public_path__ + "b889854d76d7d8e28b45fe52059e295e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/HK.svg
// module id = lk2/
// module chunks = 0